/** `/c/$companyId/purchases/suppliers?q` — the suppliers list. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";
import { SuppliersScreen } from "../suppliers/SuppliersScreen";

const search = z.object({
  q: z.string().max(200).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/suppliers/")({
  validateSearch: (raw) => search.parse(raw),
  component: SuppliersRoute,
});

function SuppliersRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.P}>
      <SuppliersScreen
        companyId={companyId}
        q={q}
        // Typing replaces the entry, so Back leaves the list instead of undoing letters.
        onSearch={(next) =>
          void navigate({ search: next === undefined ? {} : { q: next }, replace: true })
        }
      />
    </CodeGate>
  );
}
